import React from 'react';
import ExpandableList from '@gumtree/ui-library/src/expandable-list/expandable-list';
import { VipExpandableList as VipExpandableListStyle } from '../../app.style';

interface VipExpandableListProps {
	id?: string;
	title: string;
	data: string[];
	className?: string;
}

const VipExpandableList: React.FC<VipExpandableListProps> = ({
	id,
	title,
	data,
	className,
}) => {
	if (!data || data.length === 0) {
		return null;
	}

	return (
    <VipExpandableListStyle id={id} className={className}>
        <h2>{title}</h2>
        <ExpandableList
            data={data}
            isEllipsis
            expandText={
                <>
                    Show more <span className="icon icon--chevron-down" aria-hidden="true" />
                </>
            }
            collapseText={
                <>
                    Show less <span className="icon icon--chevron-up" aria-hidden="true" />
                </>
            }
            iconType="checkmark-circle"
        />
    </VipExpandableListStyle>
	);
};

export default VipExpandableList;
